import {  PayloadAction, createSlice } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../SliceKeys'
import { ConsentState } from './ConsentsSliceModels'
import { ConsentFetchModel, ConsentListItem, IAppConsentsModel } from 'service/SettingsService/SettingsServiceModels'

/**
 * Funkcja mapująca zgody z backendu na model IAppConsentsModel
 * @param consents 
 * @returns 
 */
const mapFetchedConsentsToModel = (consents: ConsentListItem[]): IAppConsentsModel[] | [] => {
   const mappedConsents: IAppConsentsModel[] = []
 
   if(!consents?.length){
      console.warn("Obiekt zgód pusty lub niezdefiniowany")
      return mappedConsents
   }
   else {
      for (const consent of consents) {
         if(consent.title){
            const mappedConsentObject: IAppConsentsModel = {
               consentId: consent.id,
               isRequired: consent.isRequired,
               text: consent.text,
               title: consent.title,
               isActive: consent.isActive,
               hasError: false,
               isChecked: false,
            }
            mappedConsents.push(mappedConsentObject)
         }
      }
   }
   return mappedConsents
}

export const initialConsentsState: ConsentState = {
   consent: [],
   appConsents: [],
}

export const consentsSlice = createSlice({
  name: SLICE_KEYS.CONSENTS_SLICE,
  initialState: initialConsentsState,
  reducers: {
      consentsFetched: (state, action: PayloadAction<ConsentFetchModel>) => {
      state.consent = action.payload.list
      },
      appConsentsFetched: (state, action: PayloadAction<ConsentFetchModel>) => {
      state.appConsents = mapFetchedConsentsToModel(action.payload.list)
      },
      appConsentsCheckOne: (state, action: PayloadAction<number>) => {
         const updatedAppConsents = state.appConsents

         for (const appConsent of updatedAppConsents) {
            if(appConsent.consentId === action.payload){
              appConsent.isChecked = !appConsent.isChecked
              appConsent.hasError = (appConsent.isRequired && !appConsent.isChecked)
              break;
            }
         }

         state.appConsents = updatedAppConsents
      },
      appConsentsValidateAll: (state) => {
         const currentAppConsents = state.appConsents
         for (const appConsent of currentAppConsents) {
            if(appConsent.isRequired === true && appConsent.isChecked === false){
               appConsent.hasError = true
            }
         }

         state.appConsents = currentAppConsents
      },
      appConsentsToggleAll: (state, action: PayloadAction<boolean>) => {
         const updatedAppConsents = state.appConsents

         for (const appConsent of updatedAppConsents) {
            appConsent.isChecked = action.payload
            appConsent.hasError = action.payload === true ? false : (appConsent.isRequired && !action.payload) // Jeśli wszystkie zgody zostały zaznaczone - kasujemy wszystkie błędy
         }

         state.appConsents = updatedAppConsents
      },
  }
})

// Action creators are generated for each case reducer function
export const { consentsFetched, appConsentsFetched, appConsentsCheckOne, appConsentsToggleAll, appConsentsValidateAll } = consentsSlice.actions

export default consentsSlice.reducer